/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarDtoFromJSON, CarDtoToJSON, FileDtoFromJSON, FileDtoToJSON, } from './';
export function GarageDtoFromJSON(json) {
    return GarageDtoFromJSONTyped(json, false);
}
export function GarageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'carsCount': !exists(json, 'carsCount') ? undefined : json['carsCount'],
        'photo': !exists(json, 'photo') ? undefined : FileDtoFromJSON(json['photo']),
        'cars': !exists(json, 'cars') ? undefined : (json['cars'] === null ? null : json['cars'].map(CarDtoFromJSON)),
    };
}
export function GarageDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'carsCount': value.carsCount,
        'photo': FileDtoToJSON(value.photo),
        'cars': value.cars === undefined ? undefined : (value.cars === null ? null : value.cars.map(CarDtoToJSON)),
    };
}
